const createSlug = (string) =>
  string.substring(0, 200).replace(/\s+/g, "-").toLowerCase()

export default createSlug
